import JustValidate from "just-validate";

// Subscribe to project newsletter
if (document.getElementById("subscribeToProjectNewsLetter")) {
  const form = new JustValidate("#subscribeToProjectNewsLetter", {
    validateBeforeSubmitting: true,
    submitFormAutomatically: false,
  });
  if (form) {
    form
      .addField("#ckEmailAddress", [
        {
          rule: "required",
          errorMessage: "Het emailadres is verplicht",
        },
        {
          rule: "email",
          errorMessage: "De ingevulde waarde voor het emailadres is incorrect",
        },
      ])
      .addField("#ckConsent", [
        {
          rule: "required",
          errorMessage: "Je moet akkoord gaan met de privacyverklaring",
        },
      ])
      .onSuccess((event) => {
        event.preventDefault();
        subscribeToNewsletter(form);
        form.refresh();
      });

    // if there are multiple projects, make choosing a project required
    if (document.getElementById("projects")) {
      form.addRequiredGroup("#projects", "Kies een project");

      // Add event listeners to update dropdown button text when project is selected
      document.querySelectorAll('input[name="form"]').forEach((radio) => {
        radio.addEventListener("change", function () {
          const dropdownButton = document.querySelector(
            "#projects .dropdown-toggle"
          );
          dropdownButton.textContent = this.parentElement.textContent.trim();
        });
      });
    }
  }
}

function subscribeToNewsletter(form) {
  const emailAddress = document.getElementById("ckEmailAddress").value;
  const formElement = document.querySelector('input[name="form"]:checked');

  if (!formElement) {
    console.error("No form selected");
    return;
  }

  const formValue = formElement.value;

  // Show loading state if elements exist
  const submitButton = document.querySelector(
    '#subscribeToProjectNewsLetter button[type="submit"]'
  );
  const originalButtonText = submitButton?.textContent;
  if (submitButton) {
    submitButton.disabled = true;
    submitButton.textContent = "Even geduld...";
  }

  fetch("/api/Newsletter", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      form: parseInt(formValue),
      emailaddress: emailAddress,
      websiteurl: location.host,
    }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json(); // Now we can safely use json() since we return structured JSON
    })
    .then((data) => {
      if (data.succeeded) {
        const successBlock = document.getElementById("autoSubscriptionSucces");
        if (successBlock) {
          successBlock.innerHTML = data.htmlContent;
          successBlock.classList.remove("d-none");
        }
      } else {
        const errorBlock = document.getElementById("autoSubscriptionError");
        if (errorBlock) {
          errorBlock.classList.remove("d-none");
        }
      }
    })
    .catch((err) => {
      console.error("Newsletter subscription error:", err);
      showMessage("error", "Er is een fout opgetreden bij het inschrijven.");
    })
    .finally(() => {
      // Restore button state
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = originalButtonText || "Inschrijven";
      }
    });
}

function showMessage(type, message) {
  // Remove any existing messages
  const existingMessages = document.querySelectorAll(".newsletter-message");
  existingMessages.forEach((msg) => msg.remove());

  // Create new message element
  const messageDiv = document.createElement("div");
  messageDiv.className = `newsletter-message alert alert-${
    type === "success" ? "success" : "danger"
  } mt-3`;
  messageDiv.textContent = message;

  // Insert after the form
  const form = document.getElementById("subscribeToProjectNewsLetter");
  if (form) {
    form.parentNode.insertBefore(messageDiv, form.nextSibling);
  }
}
